import React from 'react';
import PropTypes from 'prop-types';

/**
 * TableActions - Komponent przycisków akcji nad tabelą
 * Używa outlined/ghost buttonów zamiast standardowych
 */
const TableActions = ({ 
  actions = [],
  className = '',
  ...props 
}) => {
  if (actions.length === 0) return null;

  return (
    <div className={`flex items-center space-x-3 ${className}`} {...props}>
      {actions.map((action, index) => {
        const {
          label,
          icon: Icon,
          onClick,
          disabled = false,
          loading = false,
          variant = 'outline',
          size = 'sm',
          className: actionClassName = '',
          ...actionProps
        } = action;

        // Użyj outline dla disabled, ghost dla enabled
        const buttonVariant = disabled || loading 
          ? 'outline' 
          : variant === 'danger' 
            ? 'red-outline' 
            : 'outline';

        return (
          <button
            key={index}
            type="button"
            onClick={onClick}
            disabled={disabled || loading}
            className={`btn btn-${size} btn-square btn-${buttonVariant} ${actionClassName}`}
            {...actionProps}
          >
            {loading && (
              <svg className="animate-spin -ml-1 mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            )}
            {Icon && <Icon className="h-4 w-4 mr-2" />}
            {label}
            {action.badge && (
              <span className={`ml-1 text-xs px-1.5 py-0.5 rounded ${action.badgeClassName || 'bg-blue-100 text-blue-700'}`}>
                {action.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

TableActions.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    icon: PropTypes.elementType,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    variant: PropTypes.oneOf(['outline', 'danger', 'primary']),
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    className: PropTypes.string,
    badge: PropTypes.string,
    badgeClassName: PropTypes.string,
  })).isRequired,
  className: PropTypes.string,
};

export default TableActions;
